import React, { useState, useEffect } from 'react';
import axios from 'axios';

const Campuses = () => {
    const [campuses, setCampuses] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [editing, setEditing] = useState(null);
    const [formData, setFormData] = useState({
        name: '',
        city: '',
        address: '',
        phone: '',
        email: '',
        map_url: '',
        is_active: true,
    });

    useEffect(() => {
        fetchCampuses();
    }, []);

    const fetchCampuses = async () => {
        try {
            const token = localStorage.getItem('admin_token');
            const response = await axios.get('https://pitac.gov.pk/api/admin/campuses', {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            setCampuses(response.data);
        } catch (error) {
            console.error('Error fetching campuses:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const token = localStorage.getItem('admin_token');
            if (editing) {
                await axios.put(`https://pitac.gov.pk/api/admin/campuses/${editing.id}`, formData, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
            } else {
                await axios.post('https://pitac.gov.pk/api/admin/campuses', formData, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
            }
            fetchCampuses();
            resetForm();
        } catch (error) {
            console.error('Error saving campus:', error);
        }
    };

    const handleDelete = async (id) => {
        if (window.confirm('Are you sure you want to delete this campus?')) {
            try {
                const token = localStorage.getItem('admin_token');
                await axios.delete(`https://pitac.gov.pk/api/admin/campuses/${id}`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                fetchCampuses();
            } catch (error) {
                console.error('Error deleting campus:', error);
            }
        }
    };

    const handleEdit = (campus) => {
        setEditing(campus);
        setFormData({
            name: campus.name,
            city: campus.city,
            address: campus.address,
            phone: campus.phone || '',
            email: campus.email || '',
            map_url: campus.map_url || '',
            is_active: campus.is_active,
        });
        setShowModal(true);
    };

    const resetForm = () => {
        setFormData({
            name: '',
            city: '',
            address: '',
            phone: '',
            email: '',
            map_url: '',
            is_active: true,
        });
        setEditing(null);
        setShowModal(false);
    };

    if (loading) return <div className="admin-loading">Loading campuses...</div>;

    return (
        <div>
            <div className="admin-header">
                <h2>Campuses Management</h2>
                <button className="admin-add-btn" onClick={() => setShowModal(true)}>
                    + Add New Campus
                </button>
            </div>

            {campuses.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '3rem', color: '#6b7a8f' }}>
                    <p>No campuses found. Click "Add New Campus" to create one.</p>
                </div>
            ) : (
                <div className="admin-table-wrapper">
                    <table className="admin-table">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>City</th>
                                <th>Address</th>
                                <th>Status</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {campuses.map((campus) => (
                                <tr key={campus.id}>
                                    <td><strong>{campus.name}</strong></td>
                                    <td>{campus.city}</td>
                                    <td>{campus.address}</td>
                                    <td>
                                        <span className={`admin-status-badge ${campus.is_active ? 'admin-status-active' : 'admin-status-inactive'}`}>
                                            {campus.is_active ? 'Active' : 'Inactive'}
                                        </span>
                                    </td>
                                    <td>
                                        <div className="admin-actions">
                                            <button className="admin-edit-btn" onClick={() => handleEdit(campus)}>Edit</button>
                                            <button className="admin-delete-btn" onClick={() => handleDelete(campus.id)}>Delete</button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

            {showModal && (
                <div className="admin-modal-overlay" onClick={() => resetForm()}>
                    <div className="admin-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="admin-modal-header">
                            <h2>{editing ? 'Edit Campus' : 'Add New Campus'}</h2>
                            <button className="admin-modal-close" onClick={resetForm}>×</button>
                        </div>
                        <form onSubmit={handleSubmit}>
                            <div className="admin-form-group">
                                <label>Name *</label>
                                <input
                                    type="text"
                                    value={formData.name}
                                    onChange={(e) => setFormData({...formData, name: e.target.value})}
                                    required
                                />
                            </div>
                            <div className="admin-form-group">
                                <label>City *</label>
                                <input
                                    type="text"
                                    value={formData.city}
                                    onChange={(e) => setFormData({...formData, city: e.target.value})}
                                    required
                                />
                            </div>
                            <div className="admin-form-group">
                                <label>Address *</label>
                                <input
                                    type="text"
                                    value={formData.address}
                                    onChange={(e) => setFormData({...formData, address: e.target.value})}
                                    required
                                />
                            </div>
                            <div className="admin-form-group">
                                <label>Phone</label>
                                <input
                                    type="text"
                                    value={formData.phone}
                                    onChange={(e) => setFormData({...formData, phone: e.target.value})}
                                />
                            </div>
                            <div className="admin-form-group">
                                <label>Email</label>
                                <input
                                    type="email"
                                    value={formData.email}
                                    onChange={(e) => setFormData({...formData, email: e.target.value})}
                                />
                            </div>
                            <div className="admin-form-group">
                                <label>Map URL</label>
                                <input
                                    type="url"
                                    value={formData.map_url}
                                    onChange={(e) => setFormData({...formData, map_url: e.target.value})}
                                />
                            </div>
                            <div className="admin-form-group">
                                <label>
                                    <input
                                        type="checkbox"
                                        checked={formData.is_active}
                                        onChange={(e) => setFormData({...formData, is_active: e.target.checked})}
                                    />
                                    Active
                                </label>
                            </div>
                            <button type="submit" className="admin-submit-btn">
                                {editing ? 'Update Campus' : 'Create Campus'}
                            </button>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Campuses;